import script from "./BiodiversidadView.vue?vue&type=script&setup=true&lang=js"
export * from "./BiodiversidadView.vue?vue&type=script&setup=true&lang=js"

import "./BiodiversidadView.vue?vue&type=style&index=0&id=f02f40b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f02f40b6"]])

export default __exports__